import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";
import { z } from "zod";
export const DurationUnit = z.enum(["Ms"]);
export const DurationValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const DurationTokenData = tokenAliasOrValue(DurationValue);
